module.exports = __webpack_public_path__ + "img/Alibaba.c6aeea3d.png";